export default "__VITE_ASSET__BC8DNwiP__"